// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"8c34dfe9","667":"0a85fcc3"}[chunkId] + ".chunk.css";
};